module.exports = __webpack_public_path__ + "img/progress_047.ec8221b9.png";